import mapboxgl from 'mapbox-gl';

import CustomScaleControl from './CustomScaleControl';
import CustomZoomControl from './CustomZoomControl';

class CrewMapControlsWrapper implements mapboxgl.IControl {
  private container: HTMLDivElement | null = null;
  private zoomControl: CustomZoomControl | null = null;
  private scaleControl: CustomScaleControl | null = null;
  private zoomControlElement: HTMLElement | null = null;
  private scaleControlElement: HTMLElement | null = null;

  onAdd(map: mapboxgl.Map): HTMLElement {
    this.container = document.createElement('div');
    this.container.className = 'mapboxgl-ctrl crew-map-controls-wrapper';
    this.container.style.cssText = `
      display: flex;
      flex-direction: row;
      gap: 10px;
      background: transparent;
      border: none;
      box-shadow: none;
      padding: 0;
      margin: 0;
    `;

    this.zoomControl = new CustomZoomControl();
    this.zoomControlElement = this.zoomControl.onAdd(map);
    this.container.appendChild(this.zoomControlElement);

    this.scaleControl = new CustomScaleControl();
    this.scaleControlElement = this.scaleControl.onAdd(map);
    this.container.appendChild(this.scaleControlElement);

    return this.container;
  }

  onRemove(): void {
    if (this.zoomControl && this.zoomControlElement) {
      this.zoomControl.onRemove();
    }
    if (this.scaleControl && this.scaleControlElement) {
      this.scaleControl.onRemove();
    }
    if (this.container && this.container.parentNode) {
      this.container.parentNode.removeChild(this.container);
    }
    this.container = null;
    this.zoomControl = null;
    this.scaleControl = null;
    this.zoomControlElement = null;
    this.scaleControlElement = null;
  }

  // eslint-disable-next-line class-methods-use-this
  getDefaultPosition(): 'top-left' {
    return 'top-left';
  }
}

export default CrewMapControlsWrapper;
